import { WprControlInfo } from '../WprControlInfo';
import { WprListInfo } from './WprListInfo';
import { WprBaseViewCore } from '../../WprBaseViewCore';
import { IWprConfigOption } from '../IWprConfigOption';
import { WprRowInfo } from '../../../component/props/WprRowInfo';
import { WprControlVisibility, IWprControlState } from '../../../component/props/IWprControlState';

/**
 * リストコントロール情報
 */
export class WprListControlInfo extends WprControlInfo {
	// private 変数  ------------------------------------------------------------
	private m_ListInfo: WprListInfo					= null;			// リスト情報
	private m_UseFormControl						= true;			// フォームコントロール使用フラグ
	private m_ControlList: WprControlInfo[]			= new Array();	// コントロール情報リスト
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** フォームコントロール使用フラグ */
	public get useFormControl(): boolean 	{ return this.m_UseFormControl; }	public set useFormControl(use: boolean)	{ this.m_UseFormControl = use;	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(linfo: WprListInfo, viewCore: WprBaseViewCore, name: string, description: string, config: IWprConfigOption) {
		super(viewCore, name, description, null, config);
		this.m_ListInfo = linfo;
		this.rowIndex = 0;
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コンポーネントのステータス取得
	 * @param row 行情報
	 * @returns コントロールステータス
	 */
	public getComponentState(row?: WprRowInfo): IWprControlState {
		return this.m_ControlList[row.index].getComponentState();
	}
	// --------------------------------------------------------------------------

	// public メソッド  ---------------------------------------------------------
	/**
	 * コントロールクリア
	 */
	public clearControl(): void {
		this.m_ControlList = new Array();
	}

	/**
	 * コントロール追加
	 * @returns 追加したコントロール
	 */
	public addControl(): void {
		const control = new WprControlInfo(this.viewCore, this.name, this.description, this.modelName, undefined);
		control.validator = this.validator;
		control.config = this.config;
		control.status = this.status.clone();
		this.m_ControlList.push(control);
	}

	/**
	 * コントロール値設定
	 * @param idx 設定一
	 * @param val 値
	 */
	public setControlValue(idx: number, val: any): void {
		this.m_ControlList[idx].value = val;
	}

	/**
	 * コントロール値取得
	 * @param idx 設定一
	 * @returns 値
	 */
	public getControlValue(idx: number): any {
		return this.m_ControlList[idx].value;
	}

	/**
	 * コントロール情報取得
	 * @returns コントロール情報
	 */
	public getRowControlInfo(): WprControlInfo {
		return this.m_ControlList[this.rowIndex];
	}
	// --------------------------------------------------------------------------
}
